<template>
  <div class="wave-container">
    <WaveHeader :title="$t('Webportal.ActualWaveStatus')"
                :description="$t('Webportal.ActualWaveStatus.Description')"
                @detail-click="onDetailClick" />
    <WaveList :wave-data="waveData" />
  </div>
</template>

<script>
import WaveHeader from './WaveHeader.vue';
import WaveList from './WaveList.vue';

export default {
  name: 'WaveBoard',

  components: {
    WaveHeader,
    WaveList
  },

  props: {
    boardData:      { type: Object, required: true },
    board:          { type: Object, default: () => ({}) },
    boardSetup:     { type: Object, default: () => ({}) },
    boardIndex:     { type: Number, required: false, default: 0 },
    waveData:       { type: Object, required: true }
  },

  emits: ['detail-click'],

  methods: {
    onDetailClick() {
      this.$emit('detail-click');
    }
  }
}
</script>

<style lang="scss" scoped>
.wave-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  &:hover {
    border-color: var(--bs-border-color-translucent);
  }
}
</style>
